import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QdeService } from 'src/app/services/qde.service';
import { SharedServiceService } from '../../services/shared-service.service';
declare const submitFormMulticardingPreLogin: any;
declare var analytics: any;
@Component({
  selector: 'app-pop-up-modal',
  templateUrl: './pop-up-modal.component.html',
  styleUrls: ['./pop-up-modal.component.scss']
})
export class PopUpModalComponent implements OnInit {
  public proceedToC2S: any;
  interestedCardCategory: any;
  interestedCardType: any;
  url: string;

  constructor(public dialogRef: MatDialogRef<PopUpModalComponent>, private sharedService: SharedServiceService, private qdeService: QdeService, private http: HttpClient) { }

  ngOnInit() {
    this.proceedToC2S = JSON.parse(localStorage.getItem('convertedJson')) ? JSON.parse(localStorage.getItem('convertedJson')).root : {};
  }

  onClose() {
    this.dialogRef.close();
  }

  widgetAction() {
    const domainUrl = window.location.hostname;
    this.url = 'https://'+ domainUrl +'/creditcards/app/service/multicarding-page';
    this.interestedCardCategory = this.proceedToC2S && this.proceedToC2S.card_information ? this.proceedToC2S.card_information.card_category : '';
    this.interestedCardType = this.proceedToC2S && this.proceedToC2S.card_information ? this.proceedToC2S.card_information.card_type : '';
    console.log("interestedCardCategory", this.interestedCardCategory);
    submitFormMulticardingPreLogin(this.url, this.interestedCardCategory, this.interestedCardType);
    
    if(window['analytics']){
      analytics.track('multic__page__click_to_service', {
        'PAGE_URL': domainUrl,
        'PAGE_NAME': 'Proceed Button to C2S Multicarding',
        'MODE_OF_CONVERSION': '',
        'SOURCE_GEM_ID1': '',
        'SOURCE_GEM_ID2': '',
        'SOURCE_PAGE_URL': '',
        'IS_ORGANIC': 'Y',
        'CUSTOMER_IP_ADDRESS': '',
        'CHANNEL_NAME': 'C2S',
        'JOURNEY_NAME': 'Digital Multicarding'
      });
    }
  
    if(window['analytics']){
      analytics.track('eapply__click__proceed__on_popup_of_multicarding', {
        'PAGE_URL': domainUrl,
        'PAGE_NAME': 'Proceed Button to C2S Multicarding',
        'MODE_OF_CONVERSION': '',
        'SOURCE_GEM_ID1': '',
        'SOURCE_GEM_ID2': '',
        'SOURCE_PAGE_URL': '',
        'IS_ORGANIC': 'N',
        'CUSTOMER_IP_ADDRESS': '',
        'CHANNEL_NAME': '',
        'JOURNEY_NAME': 'Eapply',
        'CARD_TYPE':this.interestedCardType
      });
    }
  }
}
